<template>
<el-container class="project_list">
  <el-main v-loading="loading" style="height:100%">
    <div style="display: flex;justify-content: flex-start;margin-top:20px">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addWorkList">添加</el-button>
        <el-button size="mini" @click="editWorkList()">编辑</el-button>
        <el-popconfirm style="margin-left:10px"
          placement="top"
          width="260"
          icon="el-icon-info"
          iconColor="red"
          title="确定要删除吗？"
          @onConfirm="del_workList()">
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
          </div>
          <el-button size="mini" type="danger" slot="reference" @click="del_confirm_visible=true">删除</el-button>
        </el-popconfirm>
      </div>
      <el-table
        ref="multipleTable"
        :data="workLists"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" align="left"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark" v-if="scope.row.status == 0" type="info">待处理</el-tag>
            <el-tag effect="dark" v-if="scope.row.status == 1" type="info">正在处理</el-tag>
            <el-tag effect="dark" v-if="scope.row.status == 2" type="info">已处理</el-tag>
            <el-tag effect="dark" v-if="scope.row.status == 3" type="danger">退回</el-tag>
            <el-tag effect="dark" v-if="scope.row.status == 4" type="success">完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" label="创建者" width="150" align="center"></el-table-column>
        <el-table-column prop="performerName" label="执行者" width="150" align="center"></el-table-column>
        <el-table-column prop="deadline" label="最后期限" width="200" align="center" :formatter="formatDate"></el-table-column>
        <el-table-column prop="content" label="内容" align="left"></el-table-column>
        <el-table-column prop="reply" label="回复"  align="left"></el-table-column>
      </el-table>
  </el-main>
  <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisible" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="left" label-suffix="" :model="workList">
        <el-row type="flex" :gutter="20">
          <el-col :span="6">
            <el-form-item label="选择创建者">
              <el-select v-model="workList.creator" size="small" placeholder="选择创建者">
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.loginName"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择执行者">
              <el-select v-model="workList.performer" size="small" placeholder="选择执行者">
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.loginName"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作日期">
              <el-date-picker
                v-model="workList.deadline"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                placeholder="工作日期"
                @blur="
                  blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)
                "
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="清单内容">
                <el-input
                  type="textarea"
                  rows="8"
                  maxlength="1000"
                  v-model="workList.content"
                  auto-complete="off"
                />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回复内容">
                <el-input
                  type="textarea"
                  rows="8"
                  maxlength="1000"
                  v-model="workList.reply"
                  auto-complete="off"
                />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="状态">
              <el-select v-model="workList.status" size="small" placeholder="状态">
                  <el-option
                    v-for="item in statuses"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveWorkList">确 定</el-button>
      </span>
    </el-dialog>
</el-container>
</template>
<script>
import { HttpStatus } from '../../utils/httpstatus'
import { getRequest, postRequest, putRequest } from '../../utils/api'
export default {
  data () {
    return {
      workListId: 0,
      workList: {},
      workLists: [],
      pageSize: 15,
      totalCount: 0,
      currentPage: 1,
      loading: false,
      keyword: '',
      status: '0',
      statuses: [{name: '待处理', value: 0},
        {name: '正在处理', value: 1},
        {name: '已处理', value: 2},
        {name: '退回', value: 3},
        {name: '完成', value: 4}
      ],
      dlg_title: '请假',
      dialogVisible: false,
      users: [],
      selItems: []
    }
  },
  mounted: function () {
    this.loadUsers()
    this.loadWorkLists()
  },
  methods: {
    formatDate (row, column) {
      // 获取单元格数据
      let data = row[column.property]
      return this.$options.filters['formatDateTimeUctYMD'](data)
    },
    loadUsers () {
      let _this = this
      getRequest('/user/list?deptId=0').then(
        resp => {
          this.users = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadWorkList () {
      const _this = this
      var url = '/workList/' + _this.workListId
      getRequest(url).then(
        resp => {
          _this.workList = resp.data.data
          _this.totalCount = resp.data.totalCount
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadWorkLists () {
      const _this = this
      var url = '/workList/list/' + _this.currentPage + '/' + _this.pageSize
      if (this.keyword !== '') {
        url = url + '&key=' + encodeURIComponent(this.keyword)
      }
      getRequest(url).then(
        resp => {
          _this.workLists = resp.data.data.workLists
          _this.totalCount = resp.data.totalCount
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    addWorkList () {
      this.workList = {}
      this.dialogVisible = true
      this.dlg_title = '添加工作清单信息'
    },
    editWorkList () {
      var row = this.selItems[0]
      this.workListId = row.id
      this.loadWorkList()
      this.dialogVisible = true
      this.dlg_title = '编辑工作清单信息'
    },
    del_workList () {
      let _this = this
      var id = this.selItems[0].id
      putRequest('/workList/del/' + id).then(
        resp => {
          _this.$message.success('删除成功')
          this.loadWorkLists()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    saveWorkList () {
      const _this = this
      postRequest('/workList/add', this.workList).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible = false
          this.loadWorkLists()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    handleSelectionChange (val) {
      this.selItems = val
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/Views/WorkList/WorkListMana.vue